export default "__VITE_ASSET__CdgmGWIF__"